<template>
  <div>
    <b-row>
      <b-col>
        <b-form>
          <div class="date-filter-wrapper">
            <span>
              <feather-icon
                style="align-items: center; margin-left: 10px"
                icon="CalendarIcon"
                size="1.1x"
            /></span>
            <span>
              <b-form-select
                id="workcenter-date-select"
                @change="onDateSelectChange"
                style="width: max-content; border: 0px"
                v-model="selectedDateFormat"
                :options="selectOptions"
              />
            </span>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ref, computed, watch, toRefs } from "@vue/composition-api";
import { BRow, BCol, BForm, BFormSelect } from "bootstrap-vue";
import store from "@/store";
import i18n from "@/libs/i18n";
export default {
  name: "DateFilter",
  components: {
    BCol,
    BForm,

    BFormSelect,
    BRow,
  },
  props: {
    tabIndex: Number,
  },
  setup(props) {
    const acceptedFilters = [
      1, // "Hourly",
      13, // "Current Shift",
      14, // "Previous Shift",
      2, // "Daily",
      10, // "Yesterday",
    ];
    const selectedDateFormat = ref(
      store.getters["pamis-workcenter-module/GetDateFilterId"]
    );
    const { tabIndex } = toRefs(props);
    const selectOptions = computed(() => {
      const dateFilters =
        store.getters["pamis-workcenter-module/GetDateFilters"];
      dateFilters?.forEach((e) => {
        e.text = i18n.t(e.text);
      });
      if (tabIndex.value == 1) {
        //1 = Parameters tab

        return dateFilters.filter((x) =>
          acceptedFilters.some((y) => y == x.value)
        );
      }
      return dateFilters;
    });
    watch(tabIndex, () => {
      if (!acceptedFilters.some((y) => y == selectedDateFormat.value)) {
        selectedDateFormat.value = 2;
        store.dispatch(
          "pamis-workcenter-module/SetDateFilterId",
          selectedDateFormat.value
        );
      }
    });

    watch(selectOptions, (newValue) => {
      if (newValue) {
        store.dispatch("pamis/GetDateFilter", {
          value: selectedDateFormat.value,
          text: selectOptions.value.find(
            (x) => x.value == selectedDateFormat.value
          ).text,
        });
      }
    });

    function onDateSelectChange(param) {
      store.dispatch("pamis/GetDateFilter", {
        value: selectedDateFormat.value,
        text: selectOptions.value.find(
          (x) => x.value == selectedDateFormat.value
        ).text,
      });
      store.dispatch("pamis-workcenter-module/SetDateFilterId", param);
    }
    return {
      selectOptions,
      selectedDateFormat,
      onDateSelectChange,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}

.date-filter-wrapper {
  background-color: #fff;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
